import { render, staticRenderFns } from "./ServiceSetting.vue?vue&type=template&id=a361fe4c"
import script from "./ServiceSetting.vue?vue&type=script&lang=js"
export * from "./ServiceSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports